module.exports = __webpack_public_path__ + "static/media/logo.d55fcab6.svg";